// extracted by mini-css-extract-plugin
export default {"badgeContainer":"EnvBadge_badgeContainer__dB5Yk","envText":"EnvBadge_envText__Foa0j","branchText":"EnvBadge_branchText__OlMgB"};